// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { getCustomerOrderSource as getCustomerOrderSourceApi } from "@rc/App/Services/checkoutServices";
import { AnyAction } from "redux";

type ResultProps = {
    result: {
        successful: boolean;
        errorMessage?: any;
        result?: any;
    };
};

type Parameters = {
    onSuccess?: (result: any) => void;
    onError?: (e: any) => void;
};

type HandlerType = Handler<Parameters, ResultProps>;

export const BeginLoadingCustomerOrderSources: HandlerType = props => {
    // props.dispatch({
    //     type: "xCheckout/BeginLoadingValidatingAddress",
    // } as unknown as AnyAction);
};

export const RequestCustomerOrderSourcesApi: HandlerType = async props => {
    props.result = await getCustomerOrderSourceApi();
};

export const onSuccess: HandlerType = props => {
    if (props.result.successful && props.parameter.onSuccess) {
        props.parameter.onSuccess?.(props.result.result);
    }
};

export const OnError: HandlerType = props => {
    // props.dispatch({ type: "xCheckout/CompletedValidatingAddress" } as unknown as AnyAction);
    if (props.result && !props.result.successful) {
        props.parameter.onError?.(props.result.errorMessage);
    }
};

export const chain = [BeginLoadingCustomerOrderSources, RequestCustomerOrderSourcesApi, onSuccess, OnError];

const getCustomerOrderSources = createHandlerChainRunner(chain, "GetCustomerOrderSources");
export default getCustomerOrderSources;
